const authReducerDefaultState = {
  uid: '',
  message: ''
};

const authReducer = (state = authReducerDefaultState, action) => {
  switch (action.type) {
    case 'LOGIN':
      return {
        uid: action.uid
      };
    case 'LOGIN_STATUS':
      return {
        message: action.message
      };
    case 'LOGOUT':
      return {};
    default:
      return state;
  }
};

export default authReducer;
